<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('medicalorder:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="套餐名称">
                <a-input v-model="queryParam.comboName" allow-clear placeholder="请输入套餐名称" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="性别限定">
                <a-select v-model="queryParam.gender" allow-clear placeholder="请选择性别" :options="genders"></a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="订单状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择订单状态" :options="orderstates"></a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker @change="handlDate" style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData"
               :alert="options.alert"
               :rowKey="(record) => record.id"
               :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator">
          <a-button type="primary" v-if="hasPerm('buMedicalCombo:add')" icon="plus" @click="$refs.addForm.add()">新增体检套餐</a-button>

          <!--<x-down v-if="hasPerm('medicalorder:export')" ref="batchExport" @batchExport="batchExport" />-->
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="$refs.detailForm.view(record)">详情</a>

          <!-- 未发布 -->
          <span v-if="record.status == '1' ">
            <a-divider type="vertical" />
            <a @click="$refs.editForm.edit(record)">编辑</a><a-divider type="vertical" />
            <a @click="handleReleaseExamCombo(record, 2)">发布</a>
          </span>

          <!-- 已发布 -->
          <span v-if="record.status == '2' ">
            <a-divider type="vertical" />
            <a @click="handleReleaseExamCombo(record, 3)">下架</a>
          </span>

          <!-- 已下架 -->
          <span v-if="record.status == '3' ">
            <a-divider type="vertical" />
            <a @click="handleReleaseExamCombo(record, 1)">恢复</a>
          </span>
        </span>
      </s-table>

      <add-form ref="addForm" @ok="handleOk" />
      <detail-form ref="detailForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>

<script>
  import {STable, XDown} from '@/components';

  import {medComboPage, medComboExport, updateExamComboState} from '@/api/modular/interhospital/subIndividual/subIndividual';

  import addForm from './addForm.vue';
  import detailForm from './viewDetial.vue';
  import editForm from './editForm.vue';

  export default {
    components: {STable, addForm, detailForm, editForm, XDown},

    data() {
      return {
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {title: '提交时间', align: 'center', dataIndex: 'createTime'},
          {title: '套餐编号', align: 'center', dataIndex: 'comboNum'},
          {title: '套餐名称', align: 'center', dataIndex: 'comboName'},
          {
            title: '性别限定', align: 'center', dataIndex: 'gender',
            customRender: text => text == '1' ? '适用男性' : text == '2' ? '适用女性' : text == '3' ? '不限' : ''
          },
          {title: '项目数量', align: 'center', dataIndex: 'projectNumber'},
          {title: '金额（元）', align: 'center', dataIndex: 'comboPrice'},
          {
            title: '热门套餐', align: 'center', dataIndex: 'hotCombo',
            customRender: text => text == '1' ? <a-tag color="#87d068">是</a-tag> : text == '2' ? <a-tag color="#108ee9">否</a-tag> : ''
          },
          {
            title: '订单状态', align: 'center', dataIndex: 'status',
            customRender: text => text == '1' ? <a-tag color="#108ee9">未发布</a-tag> :
              text == '2' ? <a-tag color="#87d068">已发布</a-tag> : text == '3' ? <a-tag color="#f50">已下架</a-tag> : ''
          }
        ],
        tstyle: {'padding-bottom': '0px', 'margin-bottom': '10px'},
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return new Promise(async (resolve, reject) => {
            const res = await medComboPage(Object.assign(parameter, this.queryParam))
            resolve(res.data)
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: {
            show: true, clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },

        orderstates: [
          {value: '', label: '全部'},
          {value: '2', label: '未发布'},
          {value: '1', label: '已发布'},
          {value: '3', label: '已下架'},
        ],

        genders: [
          {value: '', label: '全部'},
          {value: '3', label: '不限'},
          {value: '1', label: '男'},
          {value: '2', label: '女'},
        ]
      }
    },

    created() {
      if (this.hasPerm('buMedicalCombo:edit')) {
        this.columns.push({
          title: '操作', dataIndex: 'action', align: 'center', width: '150px',
          scopedSlots: {customRender: 'action'}
        })
      }
    },

    methods: {

      /**
       * 批量导出
       */
      batchExport() {
        const paramIds = this.selectedRowKeys.map((d) => {
          return {'id': d}
        })
        medComboExport(paramIds).then((res) => {
          this.$refs.batchExport.downloadfile(res)
        })
      },

      // 1、创建时间
      handlDate(date, dateString) {
        this.queryParam.startTime = dateString[0];
        this.queryParam.endTime = dateString[1];
      },

      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
      },

      /**3、发布、恢复、下架 体检套餐 add 24.10.24*/
      handleReleaseExamCombo(record, flag) {
        this.$confirm({
          title: '提示信息',
          content: `确认要${flag == 1 ? '恢复' : flag == 2 ? '发布' : flag == 3 ? '下架' : ''}【${record.comboName}】此体检套餐?`,
          okText: '确定', cancelText: '取消',
          onOk: () => {
            updateExamComboState({id: record.id, status: flag}).then((res) => {
              if (res.code == 200) {
                this.$message.success('操作成功');
                this.$refs.table.refresh();
              } else {
                this.$message.error('操作失败');
              }
            });
          }
        });
      },

      // 4、刷新列表
      handleOk() {
        this.$refs.table.refresh()
      },
    }
  }
</script>

<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }

  button {
    margin-right: 8px;
  }

</style>
